import { gettext } from '@eventbrite/i18n';
import {
    CalendarIcon,
    ChevronDownIcon,
    HelpIcon,
    TicketIcon,
} from '@eventbrite/marmalade';
import React from 'react';
import { navigationProps } from '../modules/types';

export const defaultNavigation = ({
    defaultLanguage,
}: {
    defaultLanguage: string;
}): navigationProps => {
    return {
        desktop: [
            { path: 'd/local/events/', text: gettext('Find Events') },
            {
                path: 'manage/events/create/',
                text: gettext('Create Events'),
            },
            {
                text: gettext('Help Center'),
                iconType: <ChevronDownIcon />,
                iconPosition: 'right',
                dropdownItems: [
                    { path: 'help/', text: gettext('Help Center') },
                    {
                        path: `help/${defaultLanguage}/articles/319355/where-are-my-tickets/`,
                        text: gettext('Find your tickets'),
                    },
                    {
                        path: `help/${defaultLanguage}/articles/647151/how-to-contact-the-event-organizer/`,
                        text: gettext('Contact your event organizer'),
                    },
                ],
            },
        ],

        mobile: [
            {
                path: 'd/local/events/',
                text: gettext('Find Tickets'),
                iconType: <TicketIcon />,
            },
            {
                path: 'organizer/overview/',
                text: gettext('Create Events'),
                iconType: <CalendarIcon />,
                dropdownItems: [
                    {
                        text: gettext('Solutions'),
                        dropdownItems: [
                            {
                                path: 'l/sell-tickets/',
                                text: gettext('Event Ticketing'),
                            },
                            {
                                path: 'boost/',
                                text: gettext('Marketing Suite'),
                            },
                            {
                                path: 'l/eventbrite-ads/',
                                text: gettext('Eventbrite Ads'),
                            },
                            {
                                path: 'l/event-payment/',
                                text: gettext('Payments'),
                            },
                        ],
                    },
                    {
                        text: gettext('Industry'),
                        dropdownItems: [
                            {
                                path: 'l/music/',
                                text: gettext('Music'),
                            },
                            {
                                path: 'l/food-drink-event-ticketing/',
                                text: gettext('Food & Beverage'),
                            },
                            {
                                path: 'l/performing-arts/',
                                text: gettext('Performing Arts'),
                            },
                            {
                                path: 'l/npo/',
                                text: gettext('Charity & Causes'),
                            },
                            {
                                path: 'l/host-retail-events/',
                                text: gettext('Retails'),
                            },
                        ],
                    },
                    {
                        text: gettext('Event Types'),
                        dropdownItems: [
                            {
                                path: 'l/music-venues/',
                                text: gettext('Concerts'),
                            },
                            {
                                path: 'l/create-a-workshop/',
                                text: gettext('Classes & Workshops'),
                            },
                            {
                                path: 'l/festival-solutions/',
                                text: gettext('Festivals & Fairs'),
                            },
                            {
                                path: 'l/conferences/',
                                text: gettext('Conferences'),
                            },
                            {
                                path: 'l/eventbrite-for-business/',
                                text: gettext('Corporate Events'),
                            },
                            {
                                path: 'l/virtual-events-platform/',
                                text: gettext('Online Events'),
                            },
                        ],
                    },
                    {
                        text: gettext('Blog'),
                        dropdownItems: [
                            {
                                path: 'blog/category/tips-and-guides/',
                                text: gettext('Tips & Guides'),
                            },
                            {
                                path: 'blog/category/news-and-trends/',
                                text: gettext('News & Trends'),
                            },
                            {
                                path: 'blog/category/community/',
                                text: gettext('Community'),
                            },
                            {
                                path: 'blog/category/tools-and-features/',
                                text: gettext('Tools & Features'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'manage/events/create/',
                text: gettext('Create Events'),
            },
            {
                path: 'l/contact-eventbrite-sales/',
                text: gettext('Contact Sales'),
            },
            {
                // TODO: Verify if this link always assumes creator intent
                path: 'signin/signup/?referrer=/manage/events/create/',
                text: gettext('Get Started'),
                textColor: '#3659E3',
            },
            {
                text: gettext('Help Center'),
                iconType: <HelpIcon />,
                dropdownItems: [
                    { path: 'help/', text: gettext('Help Center') },
                    {
                        path: `help/${defaultLanguage}/articles/319355/where-are-my-tickets/`,
                        text: gettext('Find your tickets'),
                    },
                    {
                        path: `help/${defaultLanguage}/articles/647151/how-to-contact-the-event-organizer/`,
                        text: gettext('Contact your event organizer'),
                    },
                ],
            },
        ],
    };
};
